<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Seach</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="seachBox">
      <div class="seachInputBox">
             <input type="text" class="seachInput" placeholder="Please enter the name of the data you want to query." v-model="searchVal">
             <button type="button" class="el-button el-button--default" @click="getseachdataFn()"><span>搜索</span></button>
      </div>
      <div class="noneData"  v-if='searchList.length == 0' >没有找到您想要查阅的资料</div>
      <ul v-if='searchList.length != 0' >
        <li v-for='(item,key) in searchList' :key = 'key'>
          <router-link v-if='item.type == "news"' :to="{name:'newsMain',params:{id:item.id}}">
            <span>{{item.title}}</span>
            <span>{{item.date}}</span>
          </router-link>
          <router-link v-if='item.type == "publications"' :to="{name:'publicationsMain',params:{id:item.id}}">
            <span>{{item.title}}</span>
            <span>{{item.date}}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import "@/assets/css/search.less";
import apiSign from "../assets/js/apiSign";
const datalist = [
  {
    title:'测试出版物',
    date:'2019-09-16',
    id:1,
    type:1
  },
  {
    title:'Prof.Teck-Peng Loh Visited Our Lab.',
    id:2,
    date:'2019-09-16',
    type:1
  },
  {
    title:'啊飒飒大',
    date:'2019-09-16',
    id:1,
    type:2
  },
]
export default {
  data() {
    return {
      searchVal:"",
      searchList:datalist
    };
  },
  mounted(){
    this.searchVal = this.$route.params.seachval.replace(/[!@#$&*()=:/;?+']+/,"");
    this.getseachdataFn();
  },
  methods: {
    getseachdataFn() {
      let searchVal = this.searchVal.replace(/[!@#$&*()=:/;?+']+/,"");
      this.searchVal = searchVal;
      let field = { rtime: apiSign.getTime(),search:searchVal};
      this.axios.get(this.axios.defaults.baseURL + "/yiwei/app/search", {
        headers: {
          sign: apiSign.sign(field)
        },
        params: field
      }).then(resp=>{
        this.searchList = resp.data.data;
      });
    },
  }
};
</script>
<style>
</style>

